/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Get_InvolvedInputs */

const en_header_get_involved = /** @type {(inputs: Header_Get_InvolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get involved`)
};

/**
* | output |
* | --- |
* | "Get involved" |
*
* @param {Header_Get_InvolvedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_get_involved = /** @type {((inputs?: Header_Get_InvolvedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Get_InvolvedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_get_involved(inputs)
});